import React, { useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  catalogueAcceptedByTrader,
  catalogueRejectedByTrader,
  getCatelogueDetails,
} from "../../../../../redux/action/catalogue";
import { Tooltip as ReactTooltip } from "react-tooltip";
import TableLoader from "../../../../loader/TableLoader";
import {
  checkApprovedCatalogue,
  formate24hrsTo12hrs,
  formatFileSize,
  getTimeFromdate,
  handleDateSetUp,
  NoItemsLeftInTable,
} from "../../../../../helpers/helpers";
import { useState } from "react";
import { Modal } from "react-materialize";
import { ClipLoader } from "react-spinners";

function CatelogueTable() {
  const navigate = useNavigate();
  const { id } = useParams();
  const dispatch = useDispatch();
  const [catalogueList, setCatalogueList] = useState([]);
  const isTablet = useMediaQuery({ query: "(max-width: 990px)" });
  const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);
  const [isAcceptModalOpen, setIsAcceptModalOpen] = useState(false);
  const [rejectedMessage, setRejectMessage] = useState("");
  const { catelogue, CatelogueLoading, loading } = useSelector(
    (pre) => pre?.catelogueData
  );

  function convertObjectToArray(obj) {
    if (obj?.length === 0) return [];
    if (Object.keys(obj).length === 0) {
      return [];
    }
    return [obj];
  }

  const closeRejectModal = () => {
    setIsRejectModalOpen(false);
  };

  const closeAcceptModal = () => {
    setIsAcceptModalOpen(false);
  };

  useEffect(() => {
    dispatch(getCatelogueDetails(id));
  }, [id, dispatch]);

  useEffect(() => {
    const arrayObjOfCatalogue = convertObjectToArray(catelogue);
    setCatalogueList(arrayObjOfCatalogue);
  }, [catelogue]);


  if (CatelogueLoading) {
    return (
      <div className="valign-wrapper justify-center cover white mt-1">
        <TableLoader
          headerData={[
            "File Name",
            "File Size",
            "Created at",
            "Last update",
            "Terms",
            "View",
          ]}
        />
      </div>
    );
  }

  return (
    <div className={`mt-1 ${!isTablet && "table-container-style"}`}>
      <table
        className={`responsive-table centered ${isTablet ? "auction_table table-style" : "custom-table-style"
          } `}
      >
        <thead>
          <tr>
            <th>File Name</th>
            <th>File Size</th>
            <th>Created at</th>
            <th>Last update</th>
            <th>Terms</th>
            <th>View</th>
          </tr>
        </thead>

        <tbody>
          {catalogueList?.map((item) => (
            <tr key={item?._id}>
              <td style={{ width: !isTablet ? "300px" : "auto" }}>
                <span className="NoOfline" style={{ WebkitLineClamp: 1 }}>
                  {item?.fileName}
                </span>
              </td>
              <td>{formatFileSize(item?.fileSize)}</td>
              <td> {handleDateSetUp(item?.createdAt)}</td>
              <td>
                {formate24hrsTo12hrs(getTimeFromdate(item?.updatedAt))},{" "}
                {handleDateSetUp(item?.updatedAt)}
              </td>
              <td style={{ width: "230px", margin: "auto" }}>
                
                  <span className="flex justify-center gap-1">
                    <button
                      className="button-style pointer white-text green"
                      style={{ padding: "5px 15px" }}
                      onClick={() => setIsAcceptModalOpen(true)}
                    >
                      Accept
                    </button>
                    <button
                      className="button-style pointer white-text red"
                      style={{ padding: "5px 15px" }}
                      onClick={() => setIsRejectModalOpen(true)}
                    >
                      Reject
                    </button>
                  </span>
            
              </td>

              <td>
                <button
                  className={`material-icons pointer ${checkApprovedCatalogue(catelogue?.industryApproval?.status)
                    ? "grey-text"
                    : "cercle-purple-text"
                    }`}
                  disabled={checkApprovedCatalogue(
                    catelogue?.industryApproval?.status
                  )}
                  onClick={() => navigate(`/catalogue-view/${item?._id}`)}
                  data-tooltip-id={`${checkApprovedCatalogue(
                    catelogue?.industryApproval?.status
                  ) && "view-catalogue"
                    }`}
                >
                  visibility
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {catalogueList?.length === 0 && <NoItemsLeftInTable height={"150px"}/>}
      <ReactTooltip
        id={`view-catalogue`}
        content={<p>Please wait for catalogue approval</p>}
      />

      <Modal
        actions={[]}
        bottomSheet={false}
        fixedFooter={false}
        className="modelAccount"
        id="modalView-details"
        open={isAcceptModalOpen}
        options={{
          onCloseEnd: closeAcceptModal,
        }}
      >
        <div>
          <h5>
            Are you sure you want to Accept this{" "}
            <span className="green-text">{catelogue?.fileName}</span>
          </h5>
        </div>

        <div className="flex justify-end gap-1 mt-1">
          <button
            className="green btn-small"
            onClick={() => {
              dispatch(
                catalogueAcceptedByTrader(
                  id,
                  catelogue?._id,
                  setIsAcceptModalOpen
                )
              );
            }}
          >
            {loading ? <ClipLoader color={"#fff"} size={20} /> : "Yes"}
          </button>
          <button
            className="red btn-small modal-close"
            onClick={() => setIsAcceptModalOpen(false)}
          >
            No
          </button>
        </div>
      </Modal>
      <Modal
        actions={[]}
        bottomSheet={false}
        fixedFooter={false}
        className="modelAccount"
        id="modalView-details"
        open={isRejectModalOpen}
        options={{
          onCloseEnd: closeRejectModal,
        }}
      >
        <div>
          <h5>
            Are you sure you want to Reject this{" "}
            <span className="red-text">{catelogue?.fileName}</span>
          </h5>
          <p>Reason for Rejection:</p>
          <textarea
            className="border-radius-12"
            rows="10"
            name="reason"
            value={rejectedMessage}
            style={{
              border: "10px solid transparent",
              outline: "2px solid transparent",
              minHeight: "100px",
              backgroundColor: "#f2f4fd",
            }}
            onChange={(e) => setRejectMessage(e.target.value)}
          />
        </div>

        <div className="flex justify-end gap-1 mt-1">
          <button
            className="green btn-small valign-wrapper justify-center"
            disabled={rejectedMessage === ""}
            onClick={() => {
              dispatch(
                catalogueRejectedByTrader(
                  id,
                  catelogue?._id,
                  rejectedMessage,
                  setRejectMessage,
                  setIsRejectModalOpen
                )
              );
            }}
          >
            {loading ? <ClipLoader color={"#fff"} size={20} /> : "Submit"}
          </button>
          <button
            className="red btn-small modal-close"
            onClick={() => setIsRejectModalOpen(false)}
          >
            Close
          </button>
        </div>
      </Modal>
    </div>
  );
}

export default CatelogueTable;
